export const environment = {
  production: false,
  sendgrid: {
    key: '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'
  },
  domain: 'brutsche-test.firebaseapp.com',
  apiKey: 'AIzaSyCEvDvCMKj0bgsN9KLzvpJ3x-1jeVCoS9A',
  messagingSenderID: '501414014898',
  appID: '1:501414014898:web:f1c140bfa230d65e08feab',
  stripePublishableKey: 'pk_test_Fwc2YnFkJx7JiXwBOJGmB8FT00jfHbnF45',
  stripeClientId: 'ca_FACvZOUgaF9W1q7kz6AMe4py5Si3t3zq'
};